import type { TimelineBlock as TimelineBlockType, TimelineEvent } from '../types';
import { BlockEmptyState } from './BlockEmptyState';

// ─────────────────────────────────────────────
// TimelineBlock — 行业时间轴
// Figma: 灰底卡片内，每条 = 圆点 + 竖线 rail + 日期（灰色） + 事件描述
// ─────────────────────────────────────────────
export function TimelineBlock({ block }: { block: TimelineBlockType }) {
  const rawEvents = block.events as unknown as Array<Record<string, string>>;
  const events: TimelineEvent[] = Array.isArray(rawEvents)
    ? rawEvents.map(e => ({
        date: e.date ?? '',
        // 兼容旧版 description 字段
        event: e.event ?? e.description ?? '',
      }))
    : [];

  if (events.length === 0) return <BlockEmptyState label="时间轴" />;

  return (
    <div className="bg-[#F8F8F7] rounded-[8px] p-4 space-y-4">
      {events.map((ev, idx) => (
        <div key={idx} className="flex gap-3">
          {/* Rail：圆点 + 竖线 */}
          <div className="flex flex-col items-center  gap-1">
            <div className="w-2 h-2 rounded-full bg-[#09090B] flex-shrink-0 mt-[6px]" />
            <div className="w-[1px] flex-1 bg-[#262626] min-h-[20px]" />
          </div>
          {/* 内容 */}
          <div className="flex flex-col gap-0.5">
            <span className="text-[13px] font-medium text-[#737373]">{ev.date}</span>
            <span className="text-[14px] text-[#09090B] leading-[1.6]">{ev.event}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
